import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    streamUrl:
      'https://embed.zattoo.com/?partner_id=permanent-embed&channel={channel}',
    channelPlaceholderUrl: 'https://thumb.zattic.com/{channel}/1024x576.jpg',
  }) as const) satisfies ConfigFn

export default config
